<style scoped lang="stylus" rel="stylesheet/stylus"></style>

<template>
	<a :href="url" class="nav-link">
		<slot>默认内容</slot>
	</a>
</template>

<script>
export default {
	name: 'navigationLink1',
	components: {},
	props: {
		url: String
	},
	data() {
		return {}
	}
}
</script>
